import { createFileRoute } from '@tanstack/react-router';

import { ConsentPanel } from '../../features/profile/consent-panel';

/**
 * S21 — 가입 관문과 설정 변경이 같은 화면이다 ([D113]).
 *
 * **온보딩 게이트를 걸지 않는다.** 필수 동의 전에도 열려야 하고, 게이트가 보내는 목적지가
 * 여기다 (`AC-PF-01-16`·`18`). 세션 확인은 `/account` 레이아웃이 한다.
 */
export const Route = createFileRoute('/account/consent')({
  component: ConsentPanel,
});
